import { Statistic } from 'antd'
import type { Formatter } from 'antd/es/statistic/utils'
import { LucideIcon } from 'components/LucideIcon'
import {
  OntologyRolodexEntryType,
  useTypeMetadata,
} from 'features/dynamicOntology'
import React, { FC } from 'react'
import CountUp from 'react-countup'

import { StatDisplayContainer } from './AbstractStatDisplay'

export interface StatDisplayCountProps {
  isLoading?: boolean
  title: string
  count: number
  numDecimals?: number // Number of decimal places to show, defaults to 0 (integer)
  entryType?: OntologyRolodexEntryType // Optional entry type to use ontology icon and color
}

export const StatDisplayCount: FC<StatDisplayCountProps> = ({
  title,
  count,
  isLoading,
  numDecimals = 0,
  entryType,
}) => {
  const { iconName, typeColor } = useTypeMetadata(entryType ?? '')

  const formatter: Formatter = (value) => (
    <CountUp
      duration={1}
      end={value as number}
      separator=','
      decimals={numDecimals}
      preserveValue
    />
  )

  const icon = entryType ? (
    <LucideIcon name={iconName ?? 'Box'} size={18} color={typeColor} />
  ) : undefined

  return (
    <StatDisplayContainer
      title={title}
      isLoading={isLoading ?? false}
      icon={icon}>
      <Statistic
        value={count}
        formatter={formatter}
        valueStyle={{
          fontSize: '24px',
          fontWeight: 600,
          lineHeight: 1.2,
        }}
      />
    </StatDisplayContainer>
  )
}
